import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-arrow-narrow-right",
  templateUrl: "./arrow-narrow-right.component.html",
  styleUrls: ["./arrow-narrow-right.component.scss"],
})
export class ArrowNarrowRightComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
